module.exports = __webpack_public_path__ + "img/08-阿依河.b27be4ba.jpg";